import { AccountTransferTemplate } from "@/modules/template/components";
import type { IOperationPageProps } from "@/shared/common/types";

export const AccountTransferTemplatePage = ({ isEdit }: IOperationPageProps) => (
  <AccountTransferTemplate isEdit={isEdit}/>
);
